import React from "react";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import { isMessageRead } from "../utils/messageUtils";
import "./messageReadReceipt.scss";

export default function MessageReadReceipt({ isRead, className = "" }) {
  const read = isMessageRead(isRead);
  return (
    <span
      className={`message-read-receipt ${read ? "is-read" : "is-delivered"} ${className}`.trim()}
      aria-label={read ? "Read" : "Sent"}
      title={read ? "Read" : "Sent"}
    >
      <DoneAllIcon />
    </span>
  );
}
